// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".query-box {\n  display: inline-flex;\n  margin-top: 10px;\n}\n.query-box button {\n  margin-left: 5px;\n}\n@media only screen and (max-width: 550px) {\n.query-box {\n    display: block;\n}\n.query-box button {\n    margin-top: 10px;\n}\n}", ""]);
// Exports
module.exports = exports;
